import { Card } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import React from 'react';
import penflexTheme from '../../theme/penflexTheme';

export const ThemeWrapper = ({children, title}) => (
    <ThemeProvider  theme={penflexTheme}>
        <div style={{padding: '10px'}}>
            <Card elevation={2}>{children}</Card>
        </div>
    </ThemeProvider>
);